
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="动态开启或关闭虚拟滚动" fileName="dynamic-enable.md" />
        <p>如果你存在动态开启或者关闭虚拟滚动的需求，那么只需要修改<code>virtualScrollOption.enable</code>即可。F12 查看渲染结果</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;el-button @click=&quot;switchVirtual(1)&quot;&gt;开启虚拟滚动&lt;/el-button&gt;
        &lt;el-button @click=&quot;switchVirtual(0)&quot;&gt;禁用虚拟滚动&lt;/el-button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;div&gt;虚拟滚动状态：{{ virtualScrollOption.enable ? &quot;已开启&quot; : &quot;已禁用&quot; }}&lt;/div&gt;
        &lt;br /&gt;
        &lt;ve-table
            :max-height=&quot;500&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            row-key-field-name=&quot;rowKey&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                virtualScrollOption: {
                    // 是否开启
                    enable: false,
                },
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;a&quot;,
                        title: &quot;#&quot;,
                        width: 100,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            // switch virtual scroll
            switchVirtual(enable) {
                this.virtualScrollOption.enable = enable ? true : false;
            },
            // createTableData
            createTableData() {
                let data = [];
                for (let i = 0; i &lt; 100; i++) {
                    data.push({
                        rowKey: i,
                        index: i,
                        name: `name${i}`,
                        hobby: `hobby${i}`,
                        address: `address${i}`,
                    });
                }

                this.tableData = data;
            },
        },

        mounted() {
            this.createTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{on:{"click":function($event){return _vm.switchVirtual(1)}}},[_vm._v("开启虚拟滚动")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.switchVirtual(0)}}},[_vm._v("禁用虚拟滚动")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("虚拟滚动状态："+_vm._s(_vm.virtualScrollOption.enable ? "已开启" : "已禁用"))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{attrs:{"max-height":500,"virtual-scroll-option":_vm.virtualScrollOption,"columns":_vm.columns,"table-data":_vm.tableData,"row-key-field-name":"rowKey"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                virtualScrollOption: {
                    // 是否开启
                    enable: false,
                },
                columns: [
                    {
                        field: "index",
                        key: "a",
                        title: "#",
                        width: 100,
                        align: "left",
                    },
                    {
                        field: "name",
                        key: "b",
                        title: "Name",
                        width: 200,
                        align: "left",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            // switch virtual scroll
            switchVirtual(enable) {
                this.virtualScrollOption.enable = enable ? true : false;
            },
            // createTableData
            createTableData() {
                let data = [];
                for (let i = 0; i < 100; i++) {
                    data.push({
                        rowKey: i,
                        index: i,
                        name: `name${i}`,
                        hobby: `hobby${i}`,
                        address: `address${i}`,
                    });
                }

                this.tableData = data;
            },
        },

        mounted() {
            this.createTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  